"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importDefault(require("react"));

var StyledButton = styled_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 36px;\n  height: 36px;\n  position: relative;\n  transform: rotate(0deg);\n  transition: 0.5s ease-in-out;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  z-index: 9999;\n  outline: none;\n  user-select: none;\n  padding: 0;\n\n  @media (min-width: ", "px) {\n    display: none;\n  }\n\n  span {\n    display: block;\n    position: absolute;\n    height: 4px;\n    width: 100%;\n    background: ", ";\n    border-radius: 4px;\n    opacity: 1;\n    left: 0;\n    transform: rotate(0deg);\n    transition: 0.25s ease-in-out;\n  }\n\n  span:nth-of-type(1) {\n    top: ", ";\n    transform: ", ";\n  }\n\n  span:nth-of-type(2) {\n    top: 16px;\n    opacity: ", ";\n    left: ", ";\n  }\n\n  span:nth-of-type(3) {\n    top: ", ";\n    transform: ", ";\n  }\n"], ["\n  width: 36px;\n  height: 36px;\n  position: relative;\n  transform: rotate(0deg);\n  transition: 0.5s ease-in-out;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  z-index: 9999;\n  outline: none;\n  user-select: none;\n  padding: 0;\n\n  @media (min-width: ", "px) {\n    display: none;\n  }\n\n  span {\n    display: block;\n    position: absolute;\n    height: 4px;\n    width: 100%;\n    background: ", ";\n    border-radius: 4px;\n    opacity: 1;\n    left: 0;\n    transform: rotate(0deg);\n    transition: 0.25s ease-in-out;\n  }\n\n  span:nth-of-type(1) {\n    top: ", ";\n    transform: ", ";\n  }\n\n  span:nth-of-type(2) {\n    top: 16px;\n    opacity: ", ";\n    left: ", ";\n  }\n\n  span:nth-of-type(3) {\n    top: ", ";\n    transform: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.thresholds.md;
}, function (_a) {
  var theme = _a.theme;
  return theme.header.color;
}, function (_a) {
  var isOpen = _a.isOpen;
  return isOpen ? '16px' : '4px';
}, function (_a) {
  var isOpen = _a.isOpen;
  return isOpen ? 'rotate(135deg)' : 'rotate(0deg)';
}, function (_a) {
  var isOpen = _a.isOpen;
  return isOpen ? 0 : 1;
}, function (_a) {
  var isOpen = _a.isOpen;
  return isOpen ? '-60px' : 0;
}, function (_a) {
  var isOpen = _a.isOpen;
  return isOpen ? '16px' : '28px';
}, function (_a) {
  var isOpen = _a.isOpen;
  return isOpen ? 'rotate(-135deg)' : 'rotate(0deg)';
});

exports.HamburgerButton = function (_a) {
  var isOpen = _a.isOpen,
      onToggle = _a.onToggle;
  return react_1.default.createElement(StyledButton, {
    isOpen: isOpen || false,
    onClick: function onClick(e) {
      e.preventDefault();
      onToggle();
    }
  }, react_1.default.createElement("span", null), react_1.default.createElement("span", null), react_1.default.createElement("span", null));
};

var templateObject_1;